import React from 'react';
import { Link } from 'react-router-dom';
import './PersonalCare.css';

function SkilledNursing() {
  return (
    <div className="personal-care-page">
      <header className="header">
        <nav className="navbar">
          <div className="logo">
            <Link to="/"><h1>Malach <span>Healthcare</span></h1></Link>
          </div>
          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#services">Services</Link></li>
            <li><Link to="/#contact">Contact</Link></li>
          </ul>
          <Link to="/#contact" className="btn btn-primary">Book Consultation</Link>
        </nav>
      </header>

      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Skilled Nursing Services</h1>
          <p>Licensed nurses delivering professional medical care in the comfort of your home</p>
        </div>
      </section>

      <section className="service-content">
        <div className="service-intro">
          <h2>Medical Care Where You Feel Most Comfortable</h2>
          <p>
            Recovering from illness, managing a chronic condition, or transitioning home after a hospital stay
            can be daunting. Malach Healthcare's Skilled Nursing services bring licensed, experienced nurses
            directly to your door — so you or your loved one can receive expert medical care without leaving home.
          </p>
          <p>
            Our nurses work closely with your physicians and care team to follow your individualized care plan,
            monitor progress, and respond quickly to any changes in condition.
          </p>
        </div>

        <div className="services-list">
          <h2>Our Skilled Nursing Services Include</h2>
          <div className="services-grid-detail">
            <div className="service-item">
              <div className="service-item-icon">💊</div>
              <h3>Medication Management</h3>
              <p>Administration, reconciliation, and education on medications</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🩹</div>
              <h3>Wound Care</h3>
              <p>Assessment and treatment of surgical wounds, ulcers, and injuries</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">📊</div>
              <h3>Vital Signs Monitoring</h3>
              <p>Regular monitoring of blood pressure, heart rate, oxygen levels, and temperature</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">💉</div>
              <h3>IV Therapy & Injections</h3>
              <p>Infusion therapy, injections, and catheter care as prescribed</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🫀</div>
              <h3>Chronic Disease Management</h3>
              <p>Ongoing care for diabetes, heart disease, COPD, and more</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">📋</div>
              <h3>Care Coordination</h3>
              <p>Liaison between patient, family, and physician to ensure seamless care</p>
            </div>
          </div>
        </div>

        <div className="why-choose-us">
          <h2>Why Choose Malach Healthcare Skilled Nursing?</h2>
          <ul className="benefits-list">
            <li>✓ Licensed and experienced registered nurses (RNs) and LPNs</li>
            <li>✓ Personalized care plans developed with your physician</li>
            <li>✓ Reduced risk of hospital readmission</li>
            <li>✓ Compassionate care in the comfort of home</li>
            <li>✓ Regular updates and communication with families</li>
          </ul>
        </div>

        <div className="closing-message">
          <p>
            When medical needs require professional attention, Malach Healthcare is here — bringing clinical
            expertise and heartfelt compassion directly to you.
          </p>
          <Link to="/#contact" className="btn btn-primary btn-large">Request Skilled Nursing Care</Link>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>Malach <span>Healthcare</span></h3>
            <p>Empowering golden years with compassionate care.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/#services">Services</Link></li>
              <li><Link to="/#contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 740 Main St, Waltham, MA 02451</p>
            <p>📞 (781) 697-6330</p>
            <p>✉️ info@malachhealthcare.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © 2025 | All Rights Reserved | Malach Healthcare</p>
        </div>
      </footer>
    </div>
  );
}

export default SkilledNursing;
